import { FC, JSX } from 'react'

import { PlatformBookingCard, PlatformBookingCardType } from './BookingCard'
import { PlatformCard, PlatformCardType } from './Card'

export const Platform: FC &
  PlatformCardType &
  PlatformBookingCardType = (): JSX.Element => <></>

Platform.Card = PlatformCard
Platform.BookingCard = PlatformBookingCard
